<template>
  <div id="sondage">
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">UN AFFICHAGE QUI SE REMARQUE</h2>
            <p class="lead text-muted">
              L’affichage mobile est 15 fois plus mémorisé que l’affichage
              classique
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-left"
            data-aos-duration="1300"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/75.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire"
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">ATTENTION</div>
                  <small class="h6 text-muted">
                    76% des passants remarquent facilement nos dispositifs
                    d'affichage Mobile
                  </small>
                </h5>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/59.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire."
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">MÉMORISATION</div>
                  <small class="h6 text-muted">
                    59% des personnes interrogées dans la zone d’activation ont
                    cité spontanément la marque qui communiquait
                  </small>
                </h5>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/67.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire"
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">AGRÉMENT</div>
                  <small class="h6 text-muted">
                    67% des personnes interrogées dans la zone d’activation ont
                    trouvé la stratégie originale à fort impact
                  </small>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style></style>
